import React from 'react'
import { Button, Col, Container, Row } from 'react-bootstrap'
import { Field, reduxForm } from 'redux-form'

import { onFiltrosParaEmbarqueChange } from '../actions/filtroCerealCerealVariedadYEtiquetaActions'
import { renderSelectFieldWithOptions } from '../../../../Forms/fieldRenderers'
import { FORM_FILTRO_CEREAL_CEREAL_VARIEDAD_Y_ETIQUETA } from '../../../../../config/forms'
import { CerealVariedadDropdown } from '../../../../Forms/SharedComponents/containers'
import { required } from '../../../../Forms/fieldValidators'

export let FiltroCerealCerealVariedadYEtiquetaForm = props => {
  const {
    handleSubmit,
    invalid,
    submitting
  } = props

  return (
    <form onSubmit={handleSubmit}>
      <Container fluid>
        <Row style={{ textAlign: 'left' }}>
          <Col md={6}>
            <CerealVariedadDropdown
              cerealesDeshabilitados
            />
          </Col>
          <Col md={4}>
            <Field
              validate={[required]}
              name='etiqueta'
              label='Etiqueta'
              placeholder='Etiqueta'
              options={props.etiquetas}
              component={renderSelectFieldWithOptions}
              type='text'
            />
          </Col>
          <Col md={2} className='align-self-center' >
            <Button
              variant='primary'
              type='submit'
              size='md'
              disabled={invalid || submitting}
            >Generar Reporte</Button>
          </Col>
        </Row>
      </Container>
    </form>
  )
}
FiltroCerealCerealVariedadYEtiquetaForm = reduxForm({
  form: FORM_FILTRO_CEREAL_CEREAL_VARIEDAD_Y_ETIQUETA,
  onChange: onFiltrosParaEmbarqueChange
})(FiltroCerealCerealVariedadYEtiquetaForm)
